<template>
  <v-chart class="iChart" :options="iChart" autoresize/>
</template>

<script>
import ECharts from "vue-echarts"
import "echarts/lib/chart/line"
import "echarts/lib/chart/bar"

import "echarts/lib/component/legend"
import "echarts/lib/component/title"
import "echarts/lib/component/tooltip"
import "echarts/lib/component/polar"
import "echarts/lib/component/toolbox"
import "echarts/lib/component/grid"
import "echarts/lib/component/axis"
import "echarts/lib/component/markPoint"
import "echarts/lib/component/dataset"
import "echarts/lib/component/markLine"

const labelOption = {
  show: true,
  fontSize: 12,
  rotate: 90,
  align: 'center',
  verticalAlign: 'middle',
  position: 'inside',
  formatter: function (val) {
    return Number(val.value.toFixed(1)).toLocaleString('vi-VN')
  }
};
export default {
  components: {
    "v-chart":
    ECharts
  },
  props: ['title', 'subTitle', 'colors'],
  data() {
    return {
      iChart: {
        title: {
          text: '',
          textStyle: {
            fontFamily: 'arial'
          },
          subtext: '',
          subtextStyle: {
            fontFamily: 'arial'
          },
          left: 'center'
        },
        color: [],
        barWidth: '20',
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontFamily: 'arial'
          }
        },
        legend: {
          textStyle: {
            fontFamily: 'arial',
            fontSize: 15
          },
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '7%',
          containLabel: true
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            interval: 0,
            rotate: 22,
            fontFamily: 'arial'
          },
          data: [
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn',
            'Sở Kế hoạc và Đầu tư',
            'Sở VHTT&DL',
            'Sở Tài nguyên & Môi trường',
            'Sở Nông nghiệp và Phát triển Nông thôn'
          ]
        },
        yAxis: [
          {
            type: 'value',
            nameTextStyle: {
              fontWeight: 'bold',
              align: 'left',
              fontFamily: 'arial'
            },
            min: 0,
            max: 3000,
            interval: 300,
            axisLabel: {
              formatter: function (val) {
                return Number(val.toFixed(1)).toLocaleString('vi-VN')
              }
            }
          },
          {
            type: 'value',
            nameTextStyle: {
              fontWeight: 'bold',
              align: 'center',
              fontFamily: 'arial'
            },
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: function (val) {
                return Number(val.toFixed(1)).toLocaleString('vi-VN') + ' %'
              }
            }
          }
        ],
        series: [
          {
            name: 'Vốn kế hoạch năm',
            nameTextStyle: {
              fontFamily: 'arial',
            },
            type: 'bar',
            label: labelOption,
            data: [250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600]
          },
          {
            name: 'Giải ngân',
            nameTextStyle: {
              fontFamily: 'arial'
            },
            type: 'bar',
            label: labelOption,
            tooltip: {
              valueFormatter: function (value) {
                return Number(value.toFixed(1)).toLocaleString('vi-VN');
              }
            },
            data: [150, 400, 300, 2000, 150, 400, 300, 2000, 250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600, 250, 800, 1600, 2600]
          },
          {
            color: 'red',
            type: 'line',
            name: 'Tiến độ',
            nameTextStyle: {
              fontFamily: 'arial'
            },
            symbolSize: 10,
            lineStyle: {
              width: 0
            },
            yAxisIndex: 1,
            markPoint: {
              itemStyle: {
                color: 'green'
              },
              data: [
                {xAxis: 0, yAxis: 60, value: 60},
                {xAxis: 1, yAxis: 50, value: 50 },
                {xAxis: 2, yAxis: 18.75, value: 18.75},
                {xAxis: 3, yAxis: 77, value: 77},
                {xAxis: 4, yAxis: 60, value: 60},
                {xAxis: 5, yAxis: 50, value: 50},
                {xAxis: 6, yAxis: 18.75, value: 18.75},
                {xAxis: 7, yAxis: 77, value: 77},
                {xAxis: 0, yAxis: 60, value: 60},
                {xAxis: 1, yAxis: 50, value: 50},
                {xAxis: 2, yAxis: 18.75, value: 18.75},
                {xAxis: 3, yAxis: 77, value: 77},
                {xAxis: 4, yAxis: 60, value: 60},
                {xAxis: 5, yAxis: 50, value: 50},
                {xAxis: 6, yAxis: 18.75, value: 18.75},
                {xAxis: 7, yAxis: 77, value: 77}
              ]
            },
            markLine: {
              showSymbol: false,
              label: {
                show: false
              },
              data: [
                {
                  xAxis: 0,
                  yAxis: 60
                }
              ]
            },
            data: [60, 50, 18.75, 77, 60, 50, 18.75, 77]
          }
        ]
      }
    }
  }
  ,
  created() {
    this.iChart.title.text = this.title
    this.iChart.title.subtext = this.subTitle
    this.iChart.color = this.colors
  }
}
</script>

<style scoped>
  .iChart {
    width: 100%;
  }
</style>
